import { Component, Input, OnInit} from '@angular/core';
import { CustomerModel } from '../../models/customer.model';

@Component({
    selector   : 'my-interest',
    template: require('./interest.component.html'),
    styles: [require('./interest.component.scss')]
})

export class InterestComponent implements OnInit{

    @Input() input: any;
    @Input('name') placeholder: string;
    @Input('model') model: CustomerModel;
    @Input('field') field: string;
    @Input('pattern') pattern;

    constructor() {

    }

    ngOnInit(){
        this.pattern.push(this.pattern[0]);
    }

    save(){
        this.model[this.field] = this.pattern[this.pattern.indexOf(this.model[this.field]) + 1];
        this.model.modelChange(this.field);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/components/interest/interest.component.ts